import React, { useState } from 'react';
import './Booking.css';
import StepIndicator from '../Steps/StepIndicator';
import Step1 from '../Steps/Step1';
import Step2 from '../Steps/Step2';
import Step3 from '../Steps/Step3';
import Step4 from '../Steps/Step4';
import Step5 from '../Steps/Step5';
import Step6 from '../Steps/Step6';
import ConfirmationModal from '../ConfirmationModal';

const Booking = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [showConfirmation, setShowConfirmation] = useState(false);
  
  const [bookingData, setBookingData] = useState({
    bookingId: '',
    sport: '',
    numberOfParticipants: 1,
    lessonType: '',
    instructorId: null,
    instructorName: '',
    packageType: '',
    packageQuantity: 3,
    weeksCount: 1,
    daysPerWeek: [],
    selectedWeeks: [],
    timeSlots: {},
    selectedDates: [],
    participants: [],
    contactEmail: '',
    contactPhone: '',
    paymentMethod: 'online',
    totalPrice: 0
  });

  const totalSteps = 6;

  const updateBookingData = (field, value) => {
    setBookingData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleConfirmBooking = () => {
    setShowConfirmation(true);
  };

  const resetBooking = () => {
    setCurrentStep(1);
    setShowConfirmation(false);
    setBookingData({
      bookingId: '',
      sport: '',
      numberOfParticipants: 1,
      lessonType: '',
      instructorId: null,
      instructorName: '',
      packageType: '',
      packageQuantity: 3,
      weeksCount: 1,
      daysPerWeek: [],
      selectedWeeks: [],
      timeSlots: {},
      selectedDates: [],
      participants: [],
      contactEmail: '',
      contactPhone: '',
      paymentMethod: 'online',
      totalPrice: 0
    });
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <Step1 
            bookingData={bookingData}
            updateBookingData={updateBookingData}
            nextStep={nextStep}
          />
        );
      case 2:
        return (
          <Step2 
            bookingData={bookingData}
            updateBookingData={updateBookingData}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        );
      case 3:
        return (
          <Step3 
            bookingData={bookingData}
            updateBookingData={updateBookingData}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        );
      case 4:
        return (
          <Step4 
            bookingData={bookingData}
            updateBookingData={updateBookingData}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        );
      case 5:
        return (
          <Step5 
            bookingData={bookingData}
            updateBookingData={updateBookingData}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        );
      case 6:
        return (
          <Step6 
            bookingData={bookingData}
            updateBookingData={updateBookingData}
            prevStep={prevStep}
            handleConfirmBooking={handleConfirmBooking}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="booking-container">
      <div className="booking-card">
        <StepIndicator currentStep={currentStep} totalSteps={totalSteps} />
        
        <div className="step-content">
          {renderStep()}
        </div>
      </div>

      {showConfirmation && (
        <ConfirmationModal 
          bookingData={bookingData}
          onClose={resetBooking}
        />
      )}
    </div>
  );
};

export default Booking;